import { useRoleType } from "hooks/useRoleType";
import { ROUTES } from "library/constants";
import { useLocation } from "react-router-dom";


export function useCanAddEditPhoto() {
  const location = useLocation();

  const { hasSuperAdminRole } = useRoleType();

  const isAdminPage = location.pathname.includes(ROUTES.ADMIN);

  const canEditPhoto = hasSuperAdminRole && isAdminPage;
  return canEditPhoto;
}
